const colors = {
    black: '#000',
    white: '#fff',
    midnightBlue: '#20222d',
    skyBlue: '#349bfd',
    stormyBlue: '#778797',
    charcoalGray: '#999999',
    midnightBlack: '#070707',
    slateGray: '#9b9b9b',
    slateBlue: '#262a33',
    silverGray: '#b0b0b0',
    steelBlueGray: '#b0b9c1',
    grey: '#757576',
    green: '#78a56d',
    greenLight: '#e9f3e7',
    blueDark: '#0d1444',
    blueLight: '#2894ff',
    blueLighter: '#2f98fe',
    silver: '#f1f1f1',
    bluishGray: '#696b73',
    blue: '#285f95',
    white89deg: `linear-gradient(89.85deg, #fbfbfb 0.1%, #ffffff 102.02%)`,
    white90deg: `linear-gradient(90deg, #f6f6f6 0%, #ffffff 51.09%, #efefef 100%),
    #f2f6f9;`,
    blue92deg: `linear-gradient(92.95deg, #53aff7 -12.15%, #2894ff 111.4%)`,
    black157deg: `linear-gradient(157.59deg, #181920 0%, #0f0f13 100%)`,
    shadowBlack: `0px 4px 20px rgba(0, 0, 0, 0.05)`,
    shadowBlue: `0px 10px 10px rgba(78, 172, 249, 0.2)`,
    whiteSmoke: '#f5f5f6',
    lightGray: '#f7f7f7',
    slateBlueGray: '#828c94',
    ashGray: '#afafaf',
    platinumGray: '#d9d9d9',
    red: 'red',
    darkGray: '#200E32'
}

export default colors
